import { writable } from 'svelte/store';

export const showLegendModal = writable(false);